<template>
	<v-container grid-list-xl v-if="show">
		<v-layout
			row
			wrap
			align-center
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<slot name="alert" />
			</v-flex>
		</v-layout>
		<v-layout row justify-center>
			<v-flex pa-0 xs12 lg9>
				<EditReport
					:edit-report="report"
					:closable="false"
				/>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import EditReport from '@/components/Report/EditReport';

export default {
	components: {
		EditReport,
	},
	data() {
		return {
			show: false,
		};
	},
	created() {
		// Redirect to not found if user doesn't have permission to settings
		/** @todo Improve on global level, good for now */
		this.show = this.project.userCan('manage_reports');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		report() {
			return this.$store.get('reports/currentReport');
		},
	},
};
</script>
